module.exports = __webpack_public_path__ + "img/etaxone-investors.39e6c54.webp";